import { Box, Button, Spacer, Flex, HStack, Heading, Image, Text, VStack } from "@chakra-ui/react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

// Icons
import { IconEjecutivo, IconInfo } from "../../Assets/GENERALES/Icons";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { IconCarritoOnline } from "../../Assets/HOGAR/Icons";

// Components
import SlideModal from "../../Components/Slide/SlideModal";
import enviroments from "../../Services/enviroments";
import Footer from "../../Components/Footer/Footer";

// Images
import EntelTV from '../../Assets/HOGAR/DUO/EntelTV.webp';
import Logo from '../../Assets/Logos/entel-logo2.webp';
import Disney from '../../Assets/HOGAR/disney.webp';
import Max from '../../Assets/HOGAR/DUO/max.webp';

const SelectContratacionFibra = () => {

    const [messageButton, setMessageButton] = useState('Quiero que me llamen');
    const [precioNormalSolicitado, setPrecioNormalSolicitado] = useState('');
    const [precioSolicitado, setPrecioSolicitada] = useState('');
    const [openSlideModal, setOpenSlideModal] = useState(false);
    const [planSolicitado, setPlanSolicitada] = useState('');
    const [descuentoPlan, setDescuentoPlan] = useState('');
    const [redirectPage, setRedirectPage] = useState('');
    const [typePlan, setTypePlan] = useState('');
    const [id, setId] = useState('');

    const navigate = useNavigate();
    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);
    const seccion = searchParams.get("seccion");
    const idPlan = searchParams.get("planId");
    const plan = searchParams?.get("plan");
    const type = searchParams.get("type");
    const view = searchParams.get("view");
    const oda = searchParams.get("oda");
    
    let arrayPlanesHogar = {
        "2": [
            {
                id: 1,
                plan: '600+',
                disney: true,
                dcto: '13%',
                precio: '$26.990',
                recomendado: 1,
                incluye: [
                    {
                        id: 1,
                        img: Disney
                    }
                ],
                luego: 'Precio normal: $30.990/mes',
                timeOffer: '12 meses',
                link: type === 'brand' ? 'https://appswls.entel.cl/ContratacionOnLineHogar/inicioContratacion?id=monoibasicott&origen=Becall-Brand&c2=011&tipo=f' : 'https://appswls.entel.cl/ContratacionOnLineHogar/inicioContratacion?id=monoibasicott&origen=Becall-Category&c2=011&tipo=f',
            },
            {
                id: 2,
                plan: '800+',
                disney: true,
                dcto: '13%',
                precio: '$27.990',
                recomendado: 0,
                incluye: [
                    {
                        id: 1,
                        img: Disney
                    }
                ],
                luego: 'Precio normal: $31.990/mes',
                timeOffer: '12 meses',
                link: type === 'brand' ? 'https://appswls.entel.cl/ContratacionOnLineHogar/inicioContratacion?id=monoimediumott&origen=Becall-Brand&tipo=f&c2=011' : 'https://appswls.entel.cl/ContratacionOnLineHogar/inicioContratacion?id=monoimediumott&origen=Becall-Category&tipo=f&c2=011',
            },
            {
                id: 3,
                plan: 'Giga+',
                disney: true,
                dcto: '26%',
                precio: '$28.990',
                recomendado: 0,
                incluye: [
                    {
                        id: 1,
                        img: Disney
                    }
                ],
                luego: 'Precio normal: $38.990/mes',
                timeOffer: '12 meses',
                link: type === 'brand' ? 'https://appswls.entel.cl/ContratacionOnLineHogar/inicioContratacion?id=monoiadvanceott&origen=Becall-Brand&tipo=f&c2=011' : 'https://appswls.entel.cl/ContratacionOnLineHogar/inicioContratacion?id=monoiadvanceott&origen=Becall-Category&tipo=f&c2=011',
            }
        ],
        "1": [
            {
                id: 1,
                plan: '600',
                disney: false,
                dcto: '22%',
                precio: '$17.990',
                recomendado: 1,
                luego: 'Precio normal: $22.990/mes',
                timeOffer: '12 meses',
                link: type === 'brand' ? 'https://appswls.entel.cl/ContratacionOnLineHogar/inicioContratacion?id=monoibasic&origen=Becall-Brand&c2=011&tipo=f' : 'https://appswls.entel.cl/ContratacionOnLineHogar/inicioContratacion?id=monoibasic&origen=Becall-Category&c2=011&tipo=f',
            },
            {
                id: 2,
                plan: '800',
                disney: false,
                dcto: '27%',
                precio: '$18.990',
                recomendado: 0,
                luego: 'Precio normal: $25.990/mes',
                timeOffer: '12 meses',
                link: type === 'brand' ? 'https://appswls.entel.cl/ContratacionOnLineHogar/inicioContratacion?id=monoimedium&origen=Becall-Brand&tipo=f&c2=011' : 'https://appswls.entel.cl/ContratacionOnLineHogar/inicioContratacion?id=monoimedium&origen=Becall-Category&tipo=f&c2=011',
            },
            {
                id: 3,
                plan: 'Giga',
                disney: false,
                dcto: '32%',
                precio: '$22.990',
                recomendado: 0,
                luego: 'Precio normal: $33.990/mes',
                timeOffer: '12 meses',
                link: type === 'brand' ? 'https://appswls.entel.cl/ContratacionOnLineHogar/inicioContratacion?id=monoiadvance&origen=Becall-Brand&tipo=f&c2=011' : 'https://appswls.entel.cl/ContratacionOnLineHogar/inicioContratacion?id=monoiadvance&origen=Becall-Category&tipo=f&c2=011',
            }
        ],
    };

    let arrayPlanesHogarDuo = {
        "600": [
            {
                id: 1,
                id2: 11,
                plan: '600 Megas',
                plan2: '600 TV Full+',
                incluye: [
                    {
                        id: 1,
                        img: Max
                    },
                    {
                        id: 2,
                        img: Disney
                    },
                    {
                        id: 3,
                        img: EntelTV
                    }
                ],
                dcto: '29%',
                precio: '$33.990',
                luego: 'Precio normal: $47.990/mes',
                timeOffer: '12 meses',
                link: 'https://appswls.entel.cl/ContratacionOnLineHogar/inicioContratacion?id=monoibasic&origen=BeCallpo=f&c2=011'
            },
            {
                id: 2,
                id2: 12,
                plan: '600 Megas',
                plan2: '600 TV Lite',
                incluye: [
                    {
                        id: 1,
                        img: EntelTV
                    }
                ],
                dcto: '19%',
                precio: '$29.990',
                luego: 'Precio normal: $36.990/mes',
                timeOffer: '6 meses',
                link: 'https://appswls.entel.cl/ContratacionOnLineHogar/inicioContratacion?id=monoimedium&origen=BeCall&tipo=f&c2=011'
            }
        ],
        "800": [
            {
                id: 3,
                id2: 21,
                plan: '800 Megas',
                plan2: '800 TV Full+',
                incluye: [
                    {
                        id: 1,
                        img: Max
                    },
                    {
                        id: 2,
                        img: Disney
                    },
                    {
                        id: 3,
                        img: EntelTV
                    }
                ],
                dcto: '31%',
                precio: '$34.990',
                luego: 'Precio normal: $50.990/mes',
                timeOffer: '12 meses',
                link: 'https://appswls.entel.cl/ContratacionOnLineHogar/inicioContratacion?id=monoibasic&origen=BeCallpo=f&c2=011'
            },
            {
                id: 4,
                id2: 22,
                plan: '800 Megas',
                plan2: '800 TV Lite',
                incluye: [
                    {
                        id: 1,
                        img: EntelTV
                    }
                ],
                dcto: '20%',
                precio: '$31.990',
                luego: 'Precio normal: $39.990/mes',
                timeOffer: '12 meses',
                link: 'https://appswls.entel.cl/ContratacionOnLineHogar/inicioContratacion?id=monoimedium&origen=BeCall&tipo=f&c2=011'
            }
        ],
        "Giga": [
            {
                id: 5,
                id2: 31,
                plan: '940 Megas',
                plan2: 'Giga TV Full+',
                incluye: [
                    {
                        id: 1,
                        img: Max
                    },
                    {
                        id: 2,
                        img: Disney
                    },
                    {
                        id: 3,
                        img: EntelTV
                    }
                ],
                dcto: '34%',
                precio: '$38.990',
                luego: 'Precio normal: $58.990/mes',
                timeOffer: '12 meses',
                link: 'https://appswls.entel.cl/ContratacionOnLineHogar/inicioContratacion?id=monoibasic&origen=BeCallpo=f&c2=011'
            },
            {
                id: 6,
                id2: 32,
                plan: '940 Megas',
                plan2: 'Giga TV Lite',
                incluye: [
                    {
                        id: 1,
                        img: EntelTV
                    }
                ],
                dcto: '25%',
                precio: '$35.990',
                luego: 'Precio normal: $47.990/mes',
                timeOffer: '12 meses',
                link: 'https://appswls.entel.cl/ContratacionOnLineHogar/inicioContratacion?id=monoimedium&origen=BeCall&tipo=f&c2=011'
            },
        ],
    };

    useEffect(() => {
        seccion === 'internet' 
            ? arrayPlanesHogar[view].map((planes) => {
            let numeroPlan = planes.id
            if(numeroPlan.toString() === idPlan){
                window.dataLayer.push({
                    'event': 'GARDNIevent',
                    'eventCategory': `entel ofertas - ¿como quieres contratar?`,
                    'eventAction':'info',
                    'eventLabel': 'carga',
                    'origen':'entel',
                    'segmento': 'hh',
                    'mercado':'pe',
                    'page_owner':'publico',
                    'page_type':'registro',
                    'form_name':'¿como quieres contratar tu plan?',
                    'form_step_name':'paso 0-¿como quires contratar tu plan?-nuevo cliente',
                    'form_type':'flujo digital',
                    'journey_type':'solicitud',
                    'journey_name':'hogar',
                    'eventPlan': planes.plan.toLowerCase(),
                    'price': planes.precio.replace(/[$.]/g, ''),
                    'plan_subprice': planes.luego.replace(/[$.]/g, '').replace('Precio normal: ', '').replace('/mes', ''),
                    'type_offer': planes.dcto.replace('%', 'porciento dcto'),
                    'visitor_type':'nuevo cliente',
                })
            }
            })
            : arrayPlanesHogarDuo[plan].map((planes) => {
                let numeroPlan = planes.id
                if(numeroPlan.toString() === idPlan){
                    window.dataLayer.push({
                        'event': 'GARDNIevent',
                        'eventCategory': `entel ofertas - ¿como quieres contratar?`,
                        'eventAction':'info',
                        'eventLabel': 'carga',
                        'origen':'entel',
                        'segmento': 'hh',
                        'mercado':'pe',
                        'page_owner':'publico',
                        'page_type':'registro',
                        'form_name':'¿como quieres contratar tu plan?',
                        'form_step_name':'paso 0-¿como quires contratar tu plan?-nuevo cliente',
                        'form_type':'flujo digital',
                        'journey_type':'solicitud',
                        'journey_name':'hogar',
                        'eventPlan': planes.plan.toLowerCase(),
                        'price': planes.precio.replace(/[$.]/g, ''),
                        'plan_subprice': planes.luego.replace(/[$.]/g, '').replace('Precio normal: ', '').replace('/mes', ''),
                        'type_offer': planes.dcto.replace('%', 'porciento dcto'),
                        'visitor_type':'nuevo cliente',
                    })
                }
            })
    }, []);

    const handleClickToButton = (plan, precio, luego, dcto, label) => {
        window.dataLayer.push({
            'event': 'GARDevent',
            'eventCategory': `entel ofertas - ¿como quieres contratar?`,
            'eventAction':'click to action',
            'eventLabel': label,
            'origen':'entel',
            'segmento': 'hh',
            'mercado':'pe',
            'page_owner':'publico',
            'page_type':'registro',
            'form_name':'¿como quieres contratar tu plan?',
            'form_step_name':'paso 0-¿como quires contratar tu plan?-nuevo cliente',
            'form_type': 'c2c',
            'journey_type':'solicitud',
            'journey_name': 'hogar',
            'eventPlan': plan.toLowerCase(),
            'price': precio.replace(/[$.]/g, ''),
            'plan_subprice': luego.replace(/[$.]/g, '').replace('Precio normal: ', '').replace('/mes', ''),
            'type_offer': dcto.replace('%', 'porciento dcto'),
            'visitor_type':'nuevo cliente',
        })
    };

    const infoModal = ({plan}) => {
        handleClickToButton(plan.plan, plan.precio, plan.luego, plan.dcto, 'Contratar con un ejecutivo');

        if (seccion === 'duo') {
            setTypePlan(plan?.plan2.replace('+',''));
            setId(`Fibra Duo Form Plan ${plan.id2}`);
        } else if (plan?.disney) {
            setId(`Fibra_Form_Con_Disney_Plan_${plan.id}`);
        } else if (!plan?.disney) {
            setId(`Fibra Form Plan ${plan.id}`);
        }
        setMessageButton('Quiero que me llamen');
        setPrecioNormalSolicitado(plan.luego.replace('Precio normal: ', '').replace('/mes', ''));
        setRedirectPage('');
        setPrecioSolicitada(plan.precio);
        setPlanSolicitada(plan.plan);
        setDescuentoPlan(plan.dcto);
        setOpenSlideModal(true);
    };

    const handleRedirect = ({link, luego, plan, precio, dcto}) => {
        handleClickToButton(plan, precio, luego, dcto, 'Contratar online');
        window.open(`${link}?oda=${oda}`, '_blank');
    };

    return (
        <GoogleReCaptchaProvider
            reCaptchaKey={enviroments?.site_key}
            useEnterprise={true}
        >
            {/* Navbar */}
            <Box bg='white' h='60px' borderBottom='2px solid #F4F4F4'>
                <Flex w={['95%','95%','80%','90%','90%']} py={['3','3','1.5','1.5','1.5']} px='2' mx='auto' alignItems='center' h='100%'>
                    <Image src={Logo} h='100%' onClick={() => navigate(-1)} cursor='pointer' />
                </Flex>
            </Box>

            {/* Body */}
            <Flex h={['auto','auto','85vh','85vh','85vh']} flexDirection={['column','column','row','row','row']}>
                {
                    seccion === 'internet' 
                        ? arrayPlanesHogar[view].map((planes) => (
                            planes.id === parseInt(idPlan) && <Flex key={planes.id} flexDirection={['column','column','row','row','row']}>
                                <Box w={['100%','100%','40vw','40vw','40vw']} key={planes.id} bg='white' mb='5' pt={[4,4,10,10,10]} px={[5,5,20,20,20]}>
                                    <Heading className="Bold" size='md'>
                                        Estas llevando:
                                    </Heading>

                                    <Box boxShadow='0px 0px 1.5px 0px gray' borderRadius='8px' mt='5'>
                                        {
                                            planes?.recomendado 
                                            ? <Box textAlign='center' bg='#42E8B4' borderTopRadius='8px'>
                                                <Text className='Subtitle' color='black' fontSize='lg'><b>Plan Imperdible</b></Text>
                                            </Box>
                                            : ''
                                        }
                                        
                                        <Box p='3'>
                                            <Text className="General">Internet</Text>
                                            <Text className="SemiBold" fontSize='lg'>Fibra {planes.plan.replace('Megas', '')}</Text>

                                            {
                                                planes.dcto !== '0%'
                                                && <HStack mt='3' spacing='0' >
                                                    <Text border='1px solid #42E8B4' color='black' bg='#42E8B4' px='2' className="Title" h='auto' lineHeight='1.1' borderLeftRadius='5px'>
                                                        {planes.dcto} dcto
                                                    </Text>
                                                    <Text border='1px solid #42E8B4' px='2' className="Title" lineHeight='1.1' borderRightRadius='5px'>
                                                        Oferta Online
                                                    </Text>
                                                </HStack>
                                            }

                                            <HStack my='3' spacing='1' alignItems='end'>
                                                <Heading color="#002EFF" className="Subtitle" size='xl' lineHeight='1' ></Heading>
                                                <Heading color="#002EFF" className="Subtitle" size='xl' lineHeight='0.9'>{planes.precio}</Heading>
                                                <Heading color="#002EFF" className="Subtitle" size='md' lineHeight='1' >/{planes?.timeOffer}</Heading>
                                            </HStack>
                                            <Text className="General">{planes.luego}</Text>

                                            {
                                                planes?.incluye?.length > 0 &&
                                                <Box mt='2' bg='#F3F5FF' borderRadius='12px' p='3'>
                                                    <Text className="Subtitle">Incluidos en tu plan:</Text>
                                                    <HStack spacing='4' mt='4'>
                                                        {
                                                            planes?.incluye?.map((incluye) => (
                                                                <Image borderRadius='12px' src={incluye?.img} key={incluye?.id} w='47px' />
                                                            )) 
                                                        }
                                                    </HStack>
                                                </Box>
                                            }
                                        </Box>
                                    </Box>
                                </Box>
                                <Box w={['100%','100%','60vw','60vw','60vw']} bg='#F7F7F7' py='10'>
                                    <Box w={['100%','100%','70%','70%','70%']} mx='auto' px={[5,5,0,0,0]}>
                                        <Text className='SemiBold' fontSize='2xl' my='5'>
                                            ¿Cómo quieres contratar?
                                        </Text>

                                        <VStack spacing='4'>
                                            {/* <Flex onClick={() => handleRedirect(planes)}  border='2px solid #002FFD' position='relative' w='100%' cursor='pointer' alignItems='center' borderRadius='10px' p='3' _hover={{bg:'#E2E8F0'}}>
                                                <Flex bg='#A0F3D9' px='2' borderRadius='4px' fontSize='sm' className="Subtitle" position='absolute' top='-3' right='5'>
                                                    Más rápido y fácil
                                                </Flex>
                                                <IconCarritoOnline size='35px' color='#002FFD' />
                                                <Text ml='3' className="Title" color='#002FFD' >Contratar en línea</Text>
                                                <Spacer />
                                                <BsChevronRight size='25px' color='#002FFD' />
                                            </Flex> */}

                                            <Flex boxShadow='0px 0px 2px 0px gray' w='100%' onClick={() => infoModal({plan: planes,redirect: false})} cursor='pointer' alignItems='center' borderRadius='10px' p='3' _hover={{bg:'#E2E8F0'}}>
                                                <IconEjecutivo size='35px' color='#002FFD' />
                                                <Text ml='3' className="Title">Quiero que me llamen</Text>
                                            </Flex>
                                        </VStack>

                                        <Flex bg='#F3F5FF' mt='5' alignItems='center' px='3' py='2'>
                                            <IconInfo size='25px' />
                                            <Text className="General" ml='4'>
                                                Horario de atención: Lunes a Sábado de 09:00 a 20:00 hrs.
                                            </Text>
                                        </Flex>
    
                                        <Flex justifyContent='center' mt='5 '>
                                            <Button leftIcon={<BsChevronLeft size='20px' />} onClick={() => navigate(-1)} variant='link' color='#002FFD' textDecoration='underline'>
                                                Volver al paso anterior
                                            </Button>
                                        </Flex>
                                    </Box>
                                </Box>
                            </Flex>
                        ))
                        : arrayPlanesHogarDuo[plan].map((planes) => (
                            planes.id === parseInt(idPlan) && <Flex key={planes.id}>
                                <Box w={['100%','100%','40vw','40vw','40vw']} key={planes.id} bg='white' mb='5' pt={[4,4,10,10,10]} px={[5,5,20,20,20]}>
                                    <Heading className="Bold" size='md'>
                                        Estas llevando:
                                    </Heading>

                                    <Box boxShadow='0px 0px 1.5px 0px gray' borderRadius='8px' p='3' mt='5'>
                                        <Box>
                                            <Text className="General">Dúo Pack</Text>
                                            <Text className="SemiBold" fontSize='lg'>Fibra {planes.plan2}</Text>

                                            {
                                                planes.dcto !== '0%'
                                                && <HStack mt='3' spacing='0' >
                                                    <Text border='1px solid #42E8B4' color='black' bg='#42E8B4' px='2' className="Title" h='auto' lineHeight='1.1' borderLeftRadius='5px'>
                                                        {planes.dcto} dcto
                                                    </Text>
                                                    <Text border='1px solid #42E8B4' px='2' className="Title" lineHeight='1.1' borderRightRadius='5px'>
                                                        Oferta Online
                                                    </Text>
                                                </HStack>
                                            }

                                            <HStack mt='3' spacing='1' alignItems='end'>
                                                <Heading color="#002EFF" className="Subtitle" size='xl' lineHeight='1' ></Heading>
                                                <Heading color="#002EFF" className="Subtitle" size='xl' lineHeight='0.9'>{planes.precio}</Heading>
                                                <Heading color="#002EFF" className="Subtitle" size='md' lineHeight='1' >/mes</Heading>
                                            </HStack>
                                            <Text className="General">{planes.luego}</Text>

                                            <Box mt='2' bg='#F3F5FF' borderRadius='12px' p='3'>
                                                <Text className="Subtitle">Incluidos en tu plan:</Text>
                                                <HStack spacing='4' mt='4'>
                                                    {
                                                        planes?.incluye?.length > 0 && planes?.incluye?.map((incluye) => (
                                                            <Image borderRadius='12px' src={incluye?.img} key={incluye?.id} w='47px' />
                                                        )) 
                                                    }
                                                </HStack>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                                <Box w={['100%','100%','60vw','60vw','60vw']} bg='#F7F7F7' py='10'>
                                    <Box w={['100%','100%','70%','70%','70%']} mx='auto' px={[5,5,0,0,0]}>
                                        <Text className='SemiBold' fontSize='2xl' my='5'>
                                            ¿Cómo quieres contratar?
                                        </Text>

                                        <VStack spacing='4'>
                                            {/* <Flex onClick={() => handleRedirect(planes)}  border='2px solid #002FFD' position='relative' w='100%' cursor='pointer' alignItems='center' borderRadius='10px' p='3' _hover={{bg:'#E2E8F0'}}>
                                                <Flex bg='#A0F3D9' px='2' borderRadius='4px' fontSize='sm' className="Subtitle" position='absolute' top='-3' right='5'>
                                                    Más rápido y fácil
                                                </Flex>
                                                <IconCarritoOnline size='35px' color='#002FFD' />
                                                <Text ml='3' className="Title" color='#002FFD' >Contratar en línea</Text>
                                                <Spacer />
                                                <BsChevronRight size='25px' color='#002FFD' />
                                            </Flex> */}

                                            <Flex boxShadow='0px 0px 2px 0px gray' w='100%' onClick={() => infoModal({plan: planes,redirect: false})}cursor='pointer' alignItems='center' borderRadius='10px' p='3' _hover={{bg:'#E2E8F0'}}>
                                                <IconEjecutivo size='35px' color='#002FFD' />
                                                <Text ml='3' className="Title">Quiero que me llamen</Text>
                                            </Flex>
                                        </VStack>

                                        <Flex bg='#F3F5FF' mt='5' alignItems='center' px='3' py='2'>
                                            <IconInfo size='25px' />
                                            <Text className="General" ml='4'>
                                                Horario de atención: Lunes a Sábado de 09:00 a 20:00 hrs.
                                            </Text>
                                        </Flex>
    
                                        <Flex justifyContent='center' mt='5 '>
                                            <Button leftIcon={<BsChevronLeft size='20px' />} onClick={() => navigate(-1)} variant='link' color='#002FFD' textDecoration='underline'>
                                                Volver al paso anterior
                                            </Button>
                                        </Flex>
                                    </Box>
                                </Box>
                            </Flex>
                        ))
                }
            </Flex>

            <Footer />

            {/* Abrir modal */}
            {
                openSlideModal && 
                <Box
                    position="fixed"
                    top="0"
                    left="0"
                    width="100%"
                    height="100%"
                    backgroundColor="rgba(0, 0, 0, 0.5)"
                    zIndex="9"
                >
                    <SlideModal 
                        setOpenSlideModal={setOpenSlideModal} 
                        priceTyc={precioNormalSolicitado}
                        openSlideModal={openSlideModal} 
                        linkRedirect={redirectPage}
                        messageButton={messageButton}
                        descuento={descuentoPlan}
                        price={precioSolicitado}
                        valuePhoneInitial={''}
                        submitInitial={false}
                        plan={planSolicitado}
                        typePlan={typePlan}
                        intermedia={true}
                        seccion={'Hogar'}
                        view='plan'
                        id={id}
                    />
                </Box>
            }
        </GoogleReCaptchaProvider>
    )
}

export default SelectContratacionFibra